import type { ReactNode } from "react";

import { cn } from "./cn";

export function ActionBar({
  children,
  withSafeArea = true,
  className,
}: {
  children: ReactNode;
  withSafeArea?: boolean;
  className?: string;
}) {
  return (
    <div
      data-print="hidden"
      className={cn(
        "sticky bottom-0 z-20 flex gap-3 border-t border-line-subtle bg-glass px-gutter pt-3 backdrop-blur-xl [&>*]:flex-1",
        withSafeArea ? "pb-[calc(env(safe-area-inset-bottom)+1rem)]" : "pb-4",
        className,
      )}
    >
      {children}
    </div>
  );
}
